import React from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
// import axios from 'axios';
import { useUser, useSetUser } from "../../../globals/UserContext";
// import {joinClassAction } from "../../actions/joinClass";
import { updateUserAction } from "../../../actions/updateUser";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function TeacherOrStudentModal(props) {
  const user = useUser();
  const setUser = useSetUser();

  const [value, setValue] = React.useState("yes");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = () => {
    updateUserAction(user.name, user.email, value, setUser);
    props.handleClose();
    props.setPage("classes");
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Are you a teacher?
        </Typography>
        <FormControl>
          {/* <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel> */}
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="yes"
            name="radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
          <Button
            sx={{ marginTop: "15px", marginLeft: "5px" }}
            onClick={handleSubmit}
            variant="outlined"
            color="primary"
            size="small"
          >
            Submit
          </Button>
        </FormControl>
      </Box>
    </Modal>
  );
}
